import BigNumber from "bignumber.js";

export const BN_ZERO = new BigNumber(0);
export const BN_ONE = new BigNumber(1);

export const Paths = {
  Landing: {
    Index: "/",
  },
};

export const PUSH_NOTIFICATION_STORAGE_KEY = "push-notification-register-status";
export const REGISTERED = "REGISTERED";

export const LOGIN_URL = "https://a.ntrk2.com/63577ee5-59de-45a6-ac8d-ee8bb5d2fba2";
export const REGISTER_URL = "https://a.ntrk2.com/0d816414-94cb-4b7e-bcd8-b834334c7b8e";

export const LOGIN_URL_MAP = {};

export const REGISTER_URL_MAP = {};

export const FLOATING_BANNER_URL = "";

export const DOWNLOAD_URL = "https://mxpop.loadprkw2a.com/download?openExternalBrowser=1&id=1ylnigx5g2r99b5";

export * from "./codes";
export * from "./context";
